<script lang="ts">
</script>

<footer
  class="w-full inset-x-0 bottom-0 fixed bg-sky-600 text-white font-semibold z-50 shadow-[0_-5px_15px_-3px_rgba(0,0,0,0.3)]"
>
  <div class="flex flex-col md:flex-row justify-between items-center px-8 py-4 text-base md:text-lg">
    <span class="mb-2 md:mb-0">
      © 2026 <a href="/#" class="hover:text-amber-400 transition-colors">Global Bazar</a>. All Rights Reserved.
    </span>
    <a href="https://github.com/kmistry-exe" target="_blank" rel="noopener noreferrer" class="flex items-center hover:text-amber-400 transition-colors gap-2">
      <i class="fa-brands fa-github text-xl"></i>
      <span>kmistry-exe</span>
    </a>
  </div>
</footer>
